module.exports = __webpack_public_path__ + "img/kidney.aff88369.png";